
import { Payslip } from '@/types';

// Mock Payslips
export const payslips: Payslip[] = [
  {
    id: 'payslip-1',
    employeeId: 'emp-1',
    period: 'March 2024',
    issueDate: '2024-03-28',
    council: 'Mwansabombwe Town Council',
    payPeriod: 'March 2024',
    generatedDate: '2024-03-28',
    basicSalary: 5000,
    basicPay: 11561.27,
    grossSalary: 20232.22,
    grossPayYTD: 60148.60,
    totalAllowances: 8671.95,
    totalDeductions: 4574.32,
    netSalary: 15657.90,
    allowanceBreakdown: [
      { id: 'all-1', name: 'Transport Allowance', amount: 1734.19, type: 'fixed' },
      { id: 'all-2', name: 'Housing Allowance', amount: 2312.25, type: 'fixed' },
      { id: 'all-3', name: 'Rural Hardship Allowance', amount: 2312.25, type: 'fixed' },
      { id: 'all-4', name: 'Education Allowance', amount: 2312.25, type: 'fixed' },
      { id: 'all-5', name: 'Fuel Allowance', amount: 0, type: 'fixed', value: '-' },
      { id: 'all-6', name: 'Acting Allowance', amount: 0, type: 'fixed', value: '-' },
      { id: 'all-7', name: 'Other Allowance', amount: 0, type: 'fixed', value: '-' },
      { id: 'all-8', name: 'Overtime', amount: 0, type: 'fixed', value: '-' }
    ],
    deductionBreakdown: [
      { id: 'ded-1', name: 'NAPSA', amount: 1011.61, type: 'fixed' },
      { id: 'ded-2', name: 'PAYE', amount: 3400.85, type: 'fixed' },
      { id: 'ded-3', name: 'Funeral Insurance Scheme', amount: 46.25, type: 'fixed' },
      { id: 'ded-4', name: 'Health Insurance', amount: 115.61, type: 'fixed' },
      { id: 'ded-5', name: 'PSPF', amount: 0, type: 'fixed', value: '-' },
      { id: 'ded-6', name: 'LASF', amount: 0, type: 'fixed', value: '-' },
      { id: 'ded-7', name: 'ZULAWU', amount: 0, type: 'fixed', value: '-' }
    ],
    taxMonthly: 3400.85,
    taxYTD: 10088.58,
    napsaMonthly: 1011.61,
    napsaYTD: 3007.43,
    lasfMonthly: 0,
    lasfYTD: 0,
    pspfYTD: 0,
    closingLeaveDays: 70,
    closingLeaveDaysValue: 35067.67,
    status: 'paid'
  },
  {
    id: 'payslip-2',
    employeeId: 'emp-2',
    period: 'March 2024',
    issueDate: '2024-03-28',
    council: 'Mwansabombwe Town Council',
    payPeriod: 'March 2024',
    generatedDate: '2024-03-28',
    basicSalary: 4000,
    basicPay: 10500.00,
    grossSalary: 18500.00,
    grossPayYTD: 55500.00,
    totalAllowances: 8000.00,
    totalDeductions: 4200.00,
    netSalary: 14300.00,
    allowanceBreakdown: [
      { id: 'all-9', name: 'Transport Allowance', amount: 1575.00, type: 'fixed' },
      { id: 'all-10', name: 'Housing Allowance', amount: 2100.00, type: 'fixed' },
      { id: 'all-11', name: 'Rural Hardship Allowance', amount: 2100.00, type: 'fixed' },
      { id: 'all-12', name: 'Education Allowance', amount: 2100.00, type: 'fixed' },
      { id: 'all-13', name: 'Fuel Allowance', amount: 125.00, type: 'fixed' }
    ],
    deductionBreakdown: [
      { id: 'ded-8', name: 'NAPSA', amount: 925.00, type: 'fixed' },
      { id: 'ded-9', name: 'PAYE', amount: 3100.00, type: 'fixed' },
      { id: 'ded-10', name: 'Funeral Insurance Scheme', amount: 50.00, type: 'fixed' },
      { id: 'ded-11', name: 'Health Insurance', amount: 105.00, type: 'fixed' },
      { id: 'ded-12', name: 'Advance Recovery', amount: 20.00, type: 'fixed' }
    ],
    taxMonthly: 3100.00,
    taxYTD: 9300.00,
    napsaMonthly: 925.00,
    napsaYTD: 2775.00,
    closingLeaveDays: 45,
    closingLeaveDaysValue: 21000.00,
    advanceCF: 480.00,
    status: 'paid'
  },
  {
    id: 'payslip-3',
    employeeId: 'emp-3',
    period: 'March 2024',
    issueDate: '2024-03-28',
    council: 'Mwansabombwe Town Council',
    payPeriod: 'March 2024',
    generatedDate: '2024-03-28',
    basicSalary: 3500,
    basicPay: 9800.00,
    grossSalary: 17100.00,
    grossPayYTD: 51300.00,
    totalAllowances: 7300.00,
    totalDeductions: 3800.00,
    netSalary: 13300.00,
    allowanceBreakdown: [
      { id: 'all-14', name: 'Transport Allowance', amount: 1470.00, type: 'fixed' },
      { id: 'all-15', name: 'Housing Allowance', amount: 1960.00, type: 'fixed' },
      { id: 'all-16', name: 'Rural Hardship Allowance', amount: 1960.00, type: 'fixed' },
      { id: 'all-17', name: 'Education Allowance', amount: 1960.00, type: 'fixed' }
    ],
    deductionBreakdown: [
      { id: 'ded-13', name: 'NAPSA', amount: 855.00, type: 'fixed' },
      { id: 'ded-14', name: 'PAYE', amount: 2800.00, type: 'fixed' },
      { id: 'ded-15', name: 'Funeral Insurance Scheme', amount: 45.00, type: 'fixed' },
      { id: 'ded-16', name: 'Health Insurance', amount: 100.00, type: 'fixed' }
    ],
    taxMonthly: 2800.00,
    taxYTD: 8400.00,
    napsaMonthly: 855.00,
    napsaYTD: 2565.00,
    closingLeaveDays: 40,
    closingLeaveDaysValue: 17560.00,
    status: 'approved'
  },
  {
    id: 'payslip-4',
    employeeId: 'emp-4',
    period: 'March 2024',
    issueDate: '2024-03-28',
    council: 'Mwansabombwe Town Council',
    payPeriod: 'March 2024',
    generatedDate: '2024-03-28',
    basicSalary: 3800,
    basicPay: 10200.00,
    grossSalary: 17850.00,
    grossPayYTD: 53550.00,
    totalAllowances: 7650.00,
    totalDeductions: 4000.00,
    netSalary: 13850.00,
    allowanceBreakdown: [
      { id: 'all-18', name: 'Transport Allowance', amount: 1530.00, type: 'fixed' },
      { id: 'all-19', name: 'Housing Allowance', amount: 2040.00, type: 'fixed' },
      { id: 'all-20', name: 'Rural Hardship Allowance', amount: 2040.00, type: 'fixed' },
      { id: 'all-21', name: 'Education Allowance', amount: 2040.00, type: 'fixed' }
    ],
    deductionBreakdown: [
      { id: 'ded-17', name: 'NAPSA', amount: 892.50, type: 'fixed' },
      { id: 'ded-18', name: 'PAYE', amount: 2950.00, type: 'fixed' },
      { id: 'ded-19', name: 'Funeral Insurance Scheme', amount: 47.50, type: 'fixed' },
      { id: 'ded-20', name: 'Health Insurance', amount: 102.00, type: 'fixed' },
      { id: 'ded-21', name: 'Advance Recovery', amount: 8.00, type: 'fixed' }
    ],
    taxMonthly: 2950.00,
    taxYTD: 8850.00,
    napsaMonthly: 892.50,
    napsaYTD: 2677.50,
    closingLeaveDays: 35,
    closingLeaveDaysValue: 15960.00,
    advanceCF: 292.00,
    status: 'approved'
  },
  {
    id: 'payslip-5',
    employeeId: 'emp-5',
    period: 'March 2024',
    issueDate: '2024-03-28',
    council: 'Mwansabombwe Town Council',
    payPeriod: 'March 2024',
    generatedDate: '2024-03-28',
    basicSalary: 4200,
    basicPay: 11000.00,
    grossSalary: 19250.00,
    grossPayYTD: 57750.00,
    totalAllowances: 8250.00,
    totalDeductions: 4400.00,
    netSalary: 14850.00,
    allowanceBreakdown: [
      { id: 'all-22', name: 'Transport Allowance', amount: 1650.00, type: 'fixed' },
      { id: 'all-23', name: 'Housing Allowance', amount: 2200.00, type: 'fixed' },
      { id: 'all-24', name: 'Rural Hardship Allowance', amount: 2200.00, type: 'fixed' },
      { id: 'all-25', name: 'Education Allowance', amount: 2200.00, type: 'fixed' }
    ],
    deductionBreakdown: [
      { id: 'ded-22', name: 'NAPSA', amount: 962.50, type: 'fixed' },
      { id: 'ded-23', name: 'PAYE', amount: 3250.00, type: 'fixed' },
      { id: 'ded-24', name: 'Funeral Insurance Scheme', amount: 52.50, type: 'fixed' },
      { id: 'ded-25', name: 'Health Insurance', amount: 110.00, type: 'fixed' },
      { id: 'ded-26', name: 'ZULAWU', amount: 25.00, type: 'fixed' }
    ],
    taxMonthly: 3250.00,
    taxYTD: 9750.00,
    napsaMonthly: 962.50,
    napsaYTD: 2887.50,
    closingLeaveDays: 50,
    closingLeaveDaysValue: 24450.00,
    status: 'draft'
  },
  {
    id: 'payslip-6',
    employeeId: 'emp-1',
    period: 'February 2024',
    issueDate: '2024-02-28',
    council: 'Mwansabombwe Town Council',
    payPeriod: 'February 2024',
    generatedDate: '2024-02-28',
    basicSalary: 5000,
    basicPay: 11561.27,
    grossSalary: 20232.22,
    grossPayYTD: 40116.38,
    totalAllowances: 8671.95,
    totalDeductions: 4574.32,
    netSalary: 15657.90,
    allowanceBreakdown: [
      { id: 'all-26', name: 'Transport Allowance', amount: 1734.19, type: 'fixed' },
      { id: 'all-27', name: 'Housing Allowance', amount: 2312.25, type: 'fixed' },
      { id: 'all-28', name: 'Rural Hardship Allowance', amount: 2312.25, type: 'fixed' },
      { id: 'all-29', name: 'Education Allowance', amount: 2312.25, type: 'fixed' }
    ],
    deductionBreakdown: [
      { id: 'ded-27', name: 'NAPSA', amount: 1011.61, type: 'fixed' },
      { id: 'ded-28', name: 'PAYE', amount: 3400.85, type: 'fixed' },
      { id: 'ded-29', name: 'Funeral Insurance Scheme', amount: 46.25, type: 'fixed' },
      { id: 'ded-30', name: 'Health Insurance', amount: 115.61, type: 'fixed' }
    ],
    taxMonthly: 3400.85,
    taxYTD: 6801.70,
    napsaMonthly: 1011.61,
    napsaYTD: 2023.22,
    closingLeaveDays: 67.5,
    closingLeaveDaysValue: 33790.21,
    status: 'paid'
  },
  {
    id: 'payslip-7',
    employeeId: 'emp-2',
    period: 'February 2024',
    issueDate: '2024-02-28',
    council: 'Mwansabombwe Town Council',
    payPeriod: 'February 2024',
    generatedDate: '2024-02-28',
    basicSalary: 4000,
    basicPay: 10500.00,
    grossSalary: 18500.00,
    grossPayYTD: 37000.00,
    totalAllowances: 8000.00,
    totalDeductions: 4200.00,
    netSalary: 14300.00,
    allowanceBreakdown: [
      { id: 'all-30', name: 'Transport Allowance', amount: 1575.00, type: 'fixed' },
      { id: 'all-31', name: 'Housing Allowance', amount: 2100.00, type: 'fixed' },
      { id: 'all-32', name: 'Rural Hardship Allowance', amount: 2100.00, type: 'fixed' },
      { id: 'all-33', name: 'Education Allowance', amount: 2100.00, type: 'fixed' },
      { id: 'all-34', name: 'Fuel Allowance', amount: 125.00, type: 'fixed' }
    ],
    deductionBreakdown: [
      { id: 'ded-31', name: 'NAPSA', amount: 925.00, type: 'fixed' },
      { id: 'ded-32', name: 'PAYE', amount: 3100.00, type: 'fixed' },
      { id: 'ded-33', name: 'Funeral Insurance Scheme', amount: 50.00, type: 'fixed' },
      { id: 'ded-34', name: 'Health Insurance', amount: 105.00, type: 'fixed' },
      { id: 'ded-35', name: 'Advance Recovery', amount: 20.00, type: 'fixed' }
    ],
    taxMonthly: 3100.00,
    taxYTD: 6200.00,
    napsaMonthly: 925.00,
    napsaYTD: 1850.00,
    closingLeaveDays: 42.5,
    closingLeaveDaysValue: 19925.00,
    advanceCF: 500.00,
    status: 'paid'
  }
];
